(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || preference.matches) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 });
  const reveal = (scope = document) => {
    scope.querySelectorAll('.greatx-categories__grid > li, .gx-feedback__card').forEach((element, index) => {
      if (element.classList.contains('gx-reveal')) return;
      element.classList.add('gx-reveal');
      element.style.transitionDelay = `${(index % 3) * 45}ms`;
      observer.observe(element);
    });
  };
  reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  preference.addEventListener('change', event => {
    if (!event.matches) return;
    document.querySelectorAll('.gx-reveal').forEach(element => element.classList.add('is-visible'));
    observer.disconnect();
  });
})();

/* Search hints never change a visitor's query or run while they type. */
(() => {
 const preference=matchMedia('(prefers-reduced-motion: reduce)');
 const mobile=matchMedia('(max-width:749px)');
 const root=document.documentElement;
 const fields=[...document.querySelectorAll('input[id^="GreatXSearch-"]')];
 const desktop=['Search products, brands and more','Search bedding and home essentials','Search fashion, shoes and accessories','Search kitchen, tech and everyday finds'];
 const compact=['Search products','Search brands','Search shoes','Search homewares'];
 let phrases=mobile.matches?compact:desktop,timer,phrase=0,length=0,deleting=true;
 const restore=()=>fields.forEach(field=>field.placeholder=phrases[0]);
 const blocked=()=>preference.matches||document.hidden||fields.some(field=>field===document.activeElement||field.value);
 const schedule=ms=>{clearTimeout(timer);timer=setTimeout(tick,ms);};
 function tick(){if(blocked()){restore();return;}
  length+=deleting?-1:1;
  fields.forEach(field=>field.placeholder=phrases[phrase].slice(0,Math.max(0,length)));
  if(deleting&&length<=0){deleting=false;phrase=(phrase+1)%phrases.length;schedule(250);}
  else if(!deleting&&length>=phrases[phrase].length){deleting=true;schedule(2800);}
  else schedule(deleting?28:65);
 }
 const start=()=>{clearTimeout(timer);phrases=mobile.matches?compact:desktop;restore();phrase=0;length=phrases[0].length;deleting=true;if(!blocked())schedule(2800);};
 const sync=()=>{root.classList.toggle('gx-motion-ready',!preference.matches);start();};
 fields.forEach(field=>{field.addEventListener('focus',()=>{clearTimeout(timer);restore();});field.addEventListener('input',()=>{clearTimeout(timer);restore();});field.addEventListener('blur',start);});
 document.addEventListener('visibilitychange',start);preference.addEventListener('change',sync);mobile.addEventListener('change',start);sync();
})();
